import { Col } from "react-bootstrap";
import { showErrorInput } from "../../../../utils/helperFunctions";
import { Controller } from "react-hook-form";
import React from "react";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
// import { BsPlus } from "react-icons/bs";
// import { CustomSelect } from "../../../kits/inputs/Input.tsx";
// import WebInfoContext from "../../../../context/WebInfo/WebInfoContext.ts";
// import Select from "react-select";
// import UploadFile from "../../../kits/UploadFile/index.tsx";
// import { addCommas } from "@persian-tools/persian-tools";
// import { onlyNumber } from "../../../../utils/Tools";
// import InventoryItemProduct from "./InventoryItemProduct";
// import Row from "react-bootstrap/Row";
import SunEditor from "suneditor-react";
// import CreatableSelect from "react-select/creatable";
// import useWindowSize from "../../../../utils/Uti";

const FinalDetails = ({ formControl }) => {
  return (
    <div className="w-100 pd-t-12 pd-x-12 font-14-500">
      <div
        style={{
          minHeight: "calc(100vh - 300px)",
        }}
      >
        <Col xs className="pd-x-6">
          <Controller
            control={formControl.control}
            name={"finalDescription"}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <SunEditor
                onChange={(content) => onChange(content)}
                setOptions={{
                  height: 200,
                  buttonList: [
                    [],
                    [
                      "undo",
                      "redo",
                      "font",
                      "fontSize",
                      "formatBlock",
                      "bold",
                      "underline",
                      "strike",
                      "fontColor",
                      "textStyle",
                      "removeFormat",
                      "align",
                      "horizontalRule",
                      "list",
                      "lineHeight",
                      "link",
                      "image",
                      "video",
                      "audio",
                      "imageGallery",
                      "fullScreen",
                      "preview",
                    ],
                  ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                }}
                setContents={value}
              />
            )}
          />

          {showErrorInput(formControl.formState.errors, "finalDescription")}
        </Col>
      </div>

      {/*<Col xs={12} className="mr-y-16 pd-x-6 ">*/}

      {/*    <span>برچسب ها:</span>*/}

      {/*    <Controller*/}
      {/*        name="hashtags"*/}
      {/*        control={formControl.control}*/}
      {/*        render={({field}) => (*/}
      {/*            <>*/}
      {/*                <CreatableSelect*/}
      {/*                    {...field}*/}
      {/*                    formatCreateLabel={userInput => `افزودن  "${userInput}"`}*/}
      {/*                    className="mr-t-8 he-40 lgn-medium"*/}
      {/*                    placeholder="مثال: محصول تستی"*/}
      {/*                    isMulti={true}*/}
      {/*                    labelClassName="p-0 m-0"*/}
      {/*                />*/}
      {/*                {showErrorInput(formControl.formState.errors, "hashtags")}*/}
      {/*            </>*/}
      {/*        )}*/}
      {/*    />*/}
      {/*</Col>*/}
    </div>
  );
};

export default FinalDetails;
